import { useMemo } from 'react';
import { METROID_CONFIG_URL, METROID_HPP_CONFIG_ID } from '../constants/metroid';

export function useMetroidConfig() {
  return useMemo(() => {
    // though this app is serverless, locally Next uses dev server and window is undefined
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    switch (hostname) {
      case 'www.zillow.com':
        return { metroidConfigUrl: METROID_CONFIG_URL.PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.PROD };
      case 'www.qa.zillow.net':
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.QA };
      case 'www.ra1.zillow.net':
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.RA1 };
      case 'www.ra2.zillow.net':
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.RA2 };
      default:
        // localhost
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.LOCAL };
    }
  }, []);
}
